<template>
  <div class="manstudent">
    <div class="title">
      <p>
        学生管理
        <span class="ban">班级：{{title}}</span>
        <span class="course">课程：{{courseTitle}}</span>
      </p>
      <p class="back" @click="tomanClass">
        <img src="../../assets/mine/back.png" alt />
        返回
      </p>
    </div>
    <div class="sea">
      <span>学生列表</span>
      <div class="right">
        <input type="text" placeholder="请输入关键字" v-model="key" />
        <button class="ban" @click="searchbtn">搜索</button>
        <button class="enterbtn" @click="joinbtn">导入学生</button>
        <button class="addbtn" @click="addbtn">新增学生</button>
      </div>
    </div>
    <div class="box">
      <a-table
        :columns="columns"
        :data-source="list"
        :rowKey="record=>record.id"
        :locale="{'emptyText': '暂无数据'}"
        bordered
      >
        <div slot="action" class="tableAction" slot-scope="index,record">
          <span @click="rec(record)">修改</span>
          <span @click="del(record.id,record.name)">移除</span>
        </div>
      </a-table>
    </div>
    <a-modal
      title="新增"
      :visible="addshow"
      @ok="handleOk"
      @cancel="addcancel"
      class="addclassmodal"
      okText="保存"
      cancelText="取消"
    >
      <eform :formData="formDate" class="form" ref="form">
        <div slot="name">
          <a-input
            v-decorator="['name',{rules: [{ required: true, message: ' 请输入真实姓名' },{validator:validatorName}]}]"
            class="input"
          />
        </div>
        <div slot="gender">
          <a-radio-group v-decorator="['gender',{rules: [{ required: true, message: '请输入性别' }]}]">
            <a-radio :value="1">男</a-radio>
            <a-radio :value="2">女</a-radio>
          </a-radio-group>
        </div>
        <div slot="idnum">
          <a-input
            v-decorator="['idnum',{rules: [{ required: true, message: '请输入身份证' },{validator:validatorIdnum}]}]"
            class="input"
          />
        </div>
        <div slot="phone">
          <a-input
            v-decorator="['phone',{rules: [{ required: true, message: '请输入手机号码' },{validator:validatorphone}]}]"
            class="input"
          />
        </div>
        <div slot="school">
          <a-input
            v-decorator="['school',{rules: [{ required: true, message: '请输入所属院校' }]}]"
            class="input"
          />
        </div>
        <div slot="mojor">
          <a-input v-decorator="['mojor']" class="input" />
        </div>
      </eform>
    </a-modal>
    <a-modal
      title="修改"
      :visible="recshow"
      @ok="recOk"
      @cancel="reccancel"
      :destroyOnClose="true"
      class="recmodal"
      okText="保存"
      cancelText="取消"
    >
      <eform :formData="formrec" class="form" :fields="fields" ref="form">
        <div slot="name">
          <a-input
            v-decorator="['name',{rules: [{ required: true, message: ' 请输入真实姓名' },{validator:validatorName}]}]"
            class="input"
          />
        </div>
        <div slot="gender">
          <a-radio-group v-decorator="['gender',{rules: [{ required: true, message: '请输入性别' }]}]">
            <a-radio :value="1">男</a-radio>
            <a-radio :value="2">女</a-radio>
          </a-radio-group>
        </div>
        <div slot="idnum">
          <a-input
            v-decorator="['idnum',{rules: [{ required: true, message: '请输入身份证' },{validator:validatorIdnum}]}]"
            class="input"
          />
        </div>
        <div slot="phone">
          <a-input
            v-decorator="['phone',{rules: [{ required: true, message: '请输入手机号码' },{validator:validatorphone}]}]"
            class="input"
          />
        </div>
        <div slot="school">
          <a-input
            v-decorator="['school',{rules: [{ required: true, message: '请输入所属院校' }]}]"
            class="input"
          />
        </div>
        <div slot="mojor">
          <a-input v-decorator="['mojor']" class="input" />
        </div>
      </eform>
    </a-modal>
    <downloadAndUpload
      :uploadModal="uploadModal"
      @uploadcancel="uploadModal=false"
      :templateApiurl="'personalCenter/downloadTemplate'"
      :fileName="fileName"
      @upload="upload"
    ></downloadAndUpload>
    <!-- <div class="pagemodel">
      <pagination
        :pagination="pagination"
        @changePage="changePage"
      ></pagination>
    </div>-->
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "index",
  },
  {
    title: "账号",
    dataIndex: "account",
    width: 100,
  },
  {
    title: "姓名",
    dataIndex: "name",
    width:100
  },
  {
    title: "性别",
    dataIndex: "sex",
    width:80
  },
  {
    title: "身份证号",
    dataIndex: "idnum",
  },
  {
    title: "手机号",
    dataIndex: "phone",
  },
  {
    title: "所属院校",
    dataIndex: "school",
    width: 120,
  },
  {
    title: "所在专业",
    dataIndex: "mojor",
    width: 120,
  },
  {
    title: "操作",
    scopedSlots: { customRender: "action" },
    width: 130,
  },
];
import eform from "@/components/common/form";
// import pagination from "@/components/common/pagination";
import downloadAndUpload from "@/components/common/downloadAndUpload";
import {
  getstudentApi,
  getaddstudentApi,
  getaddstudentclassApi,
  getimportUserToClassApi,
  getremovestudentApi,
  getupdatastudentApi,
} from "@/request/api";
export default {
  name: "manstudent",
  components: { eform, downloadAndUpload },
  data() {
    const formDate = [
      {
        label: "姓名",
        scopedSlots: { customRender: "name" },
      },
      {
        label: "性别",
        scopedSlots: { customRender: "gender" },
      },
      {
        label: "身份证号",
        scopedSlots: { customRender: "idnum" },
      },
      {
        label: "手机号码",
        scopedSlots: { customRender: "phone" },
      },
      {
        label: "所属院校",
        scopedSlots: { customRender: "school" },
      },
      {
        label: "所属专业",
        scopedSlots: { customRender: "mojor" },
      },
    ];
    const formrec = [
      {
        label: "姓名",
        scopedSlots: { customRender: "name" },
      },
      {
        label: "性别",
        scopedSlots: { customRender: "gender" },
      },
      {
        label: "身份证号",
        scopedSlots: { customRender: "idnum" },
      },
      {
        label: "手机号码",
        scopedSlots: { customRender: "phone" },
      },
      {
        label: "所属院校",
        scopedSlots: { customRender: "school" },
      },
      {
        label: "所属专业",
        scopedSlots: { customRender: "mojor" },
      },
    ];
    let validatorName = (rule, value, callback) => {
      let reg = /^[\u4e00-\u9fa5]/;
      if (value == "" || reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入真实姓名"));
      }
    };
    let validatorIdnum = (rule, value, callback) => {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (value == "" || reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入合法身份证"));
      }
    };
    let validatorphone = (rule, value, callback) => {
      let reg = /^1[3456789]\d{9}$/;
      if (value == "" || reg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入合法手机号"));
      }
    };

    return {
      columns,
      addshow: false,
      joinshow: true,
      formDate,
      validatorName,
      validatorIdnum,
      validatorphone,
      fields: null,
      searchInfo: {
        page: 1,
        pageSize: 10,
        keyword: "",
        classId: "",
      },
      pagination: { total: 0, pageSize: 10 },
      key: "",
      courseTitle: "",
      title: "",
      list: [],
      classId: "",
      sex: "",
      uploadModal: false,
      fileName: "班级管理——学生管理导入模板.xlsx",
      formrec,
      recshow: false,
      userId: "",
      newId: "",
    };
  },
  created() {
    this.classtitle = this.$route.query.classtitle;
    this.title = this.$route.query.title;
    this.classId = this.$route.query.id;
    this.init();
  },
  methods: {
    init() {
      this.searchInfo.classId = this.classId;
      this.getToken(getstudentApi, this.searchInfo, (res) => {
        this.title = res.data.title;
        this.courseTitle = res.data.courseTitle;
        this.list = res.data.Student.map((item, index) => ({
          index: (this.searchInfo.page - 1) * 10 + index + 1,
          account: item.account,
          name: item.realname,
          sex: item.gender,
          idnum: item.idCardNum,
          phone: item.telephone,
          school: item.instituteName,
          mojor: item.major,
          id: item.id,
        }));
      });
    },
    //返回
    tomanClass() {
      this.$router.push({ path: "/manClass" });
    },
    //导入
    joinbtn() {
      this.uploadModal = true;
    },
    //   新增
    addbtn() {
      this.addshow = true;
    },
    //确定新增
    handleOk() {
      this.$refs.form.form.validateFields().then((res) => {
        if (res.gender == 1) {
          this.sex = "男";
        } else if (res.gender == 2) {
          this.sex = "女";
        }
        //新增学生
        this.getToken(
          getaddstudentApi,
          {
            realname: res.name,
            gender: this.sex,
            major: res.mojor,
            telephone: res.phone,
            idCardNum: res.idnum,
            instituteName: res.school,
          },
          (value) => {
            //新增学生到班级
            this.getToken(
              getaddstudentclassApi,
              { userId: value.data.id, classId: this.classId },
              (req) => {
                if (req.code == 200) {
                  this.$message.success("新增成功！");
                  this.init();
                  this.addshow = false;
                  this.$refs.form.form.resetFields(["name"]);
                  this.$refs.form.form.resetFields(["gender"]);
                  this.$refs.form.form.resetFields(["mojor"]);
                  this.$refs.form.form.resetFields(["phone"]);
                  this.$refs.form.form.resetFields(["idnum"]);
                  this.$refs.form.form.resetFields(["school"]);
                }
              }
            );
          }
        );
      });
    },
    //取消
    addcancel() {
      this.addshow = false;
      this.$refs.form.form.resetFields(["name"]);
      this.$refs.form.form.resetFields(["gender"]);
      this.$refs.form.form.resetFields(["mojor"]);
      this.$refs.form.form.resetFields(["phone"]);
      this.$refs.form.form.resetFields(["idnum"]);
      this.$refs.form.form.resetFields(["school"]);
    },
    //分页
    changePage(currentPage) {
      this.searchInfo.page = currentPage;
      this.init();
    },
    //搜索
    searchbtn() {
      this.searchInfo.keyword = this.key;
      this.init();
    },
    //移除
    del(id, title) {
      this.newId = id;
      this.$confirm({
        title: `确定要移除"${title}"这个学生吗？`,
        okText: "确定",
        cancelText: "取消",
        onOk: () => {
          this.getToken(
            getremovestudentApi,
            { classId: this.classId, userId: this.newId },
            (res) => {
              if (res.code == 200) {
                this.init();
                this.$message.success("删除成功！");
              }
            }
          );
        },
        onCancel() {
          // console.log('Cancel');
        },
      });
    },
    upload(data) {
      let formData = new FormData();
      formData.append("classId", this.classId);
      formData.append("file", data[0]);
      this.getToken(getimportUserToClassApi, formData, (res) => {
        if (res.code == 200) {
          this.uploadModal = false;
          this.init();
          this.$confirm({
            title: `${res.message}"`,
            okText: "确定",
            cancelText: "取消",
            onOk: () => {
              this.init();
              this.uploadModal = false;
            },
            onCancel() {
              // console.log('Cancel');
            },
          });
        }
      });
    },
    rec(data) {
      // console.log(data)
      this.recshow = true;
      this.userId = data.id;
      this.fields = data;
      this.fields.gender = data.gender == "男" ? 1 : 2;
    },
    //修改确定
    recOk() {
      // this.$refs.form.form.setFieldsValue(["name"])=
      // this.$refs.form.form.setFieldsValue(["gender"])=
      // this.$refs.form.form.setFieldsValue(["mojor"])=
      // this.$refs.form.form.setFieldsValue(["phone"])=
      // this.$refs.form.form.setFieldsValue(["idnum"])=
      // this.$refs.form.form.setFieldsValue(["school"])=
      this.$refs.form.form.validateFields().then((res) => {
        if (res.gender == 1) {
          this.sex = "男";
        } else if (res.gender == 2) {
          this.sex = "女";
        }
        this.getToken(
          getupdatastudentApi,
          {
            userId: this.userId,
            realname: res.name,
            gender: this.sex,
            major: res.mojor,
            telephone: res.phone,
            idCardNum: res.idnum,
            instituteName: res.school,
          },
          (value) => {
            if (value.code == 200) {
              this.$message.success("修改成功");
              this.init();
              this.$refs.form.form.resetFields(["name"]);
              this.$refs.form.form.resetFields(["gender"]);
              this.$refs.form.form.resetFields(["mojor"]);
              this.$refs.form.form.resetFields(["phone"]);
              this.$refs.form.form.resetFields(["idnum"]);
              this.$refs.form.form.resetFields(["school"]);
              this.recshow = false;
            }
          }
        );
      });
    },
    //修改取消
    reccancel() {
      this.recshow = false;
      this.$refs.form.form.resetFields(["name"]);
      this.$refs.form.form.resetFields(["gender"]);
      this.$refs.form.form.resetFields(["mojor"]);
      this.$refs.form.form.resetFields(["phone"]);
      this.$refs.form.form.resetFields(["idnum"]);
      this.$refs.form.form.resetFields(["school"]);
    },
  },
};
</script>
<style >
.manstudent .ant-table table {
  text-align: center;
}
.manstudent thead {
  display: table-header-group;
  vertical-align: middle;
  border-color: inherit;
  text-align: center;
  font-weight: bolder;
  font-size: 14px;
  /* background-color: #eaeef7; */
  height: 36px;
}
.manstudent .ant-table-thead > tr > th {
  color: #333;
  font-weight: 600;
  font-size: 14px;
  /* background-color: #eaeef7; */
  height: 30px;
}
.manstudent .ant-table-bordered .ant-table-thead > tr > th,
.manstudent .ant-table-bordered .ant-table-tbody > tr > td {
  border-right: 1px solid #e8e8e8;
  text-align: center;
}
.manstudent .ant-table-pagination.ant-pagination {
  text-align: center;
  margin: 0px auto;
  margin-top: 50px;
  /* display: none; */
}
.recmodal .ant-modal-body {
  margin-top: 20px;
  padding: 0px;
  font-size: 14px;
  word-wrap: break-word;
}
</style>
<style lang="stylus" scoped>
.manstudent {
  margin-bottom: 50px;

  .title {
    height: 45px;
    line-height: 45px;
    overflow: hidden;
    border-bottom: 1px solid #eff2f2;
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      height: 45px;
      line-height: 45px;
      margin-left: 30px;
      font-size: 18px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 0px;

      .ban {
        color: #c56b2f;
        font-size: 14px;
        margin-left: 20px;
      }

      .course {
        color: #c56b2f;
        font-size: 14px;
        margin-left: 10px;
      }
    }

    .back {
      color: #4281ff;
      width: 50px;
      height: 30px;
      font-size: 14px;
      margin-right: 20px;
      line-height: 30px;
      cursor: pointer;

      img {
        width: 15px;
        height: 15px;
        margin-top: -3px;
      }
    }
  }

  .sea {
    height: 45px;
    margin-left: 30px;
    margin-right:30px;
    margin-top: 20px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    position: relative;

    span {
      color: #333;
      font-size: 16px;
      width:435px;
    }

    .right {
      flex:1;
      justify-content space-around;
      input {
        outline: none;
        width: 220px;
        height: 35px;
        border: solid 1px #d4d4d4;
        text-indent: 8px;
      }

      .ban {
        outline: none;
        width: 60px;
        height: 35px;
        background-color: #4281ff;
        color: #ffffff;
        font-size: 14px;
        cursor: pointer;
        border: 0;
      }

      .enterbtn {
        width: 75px;
        height: 35px;
        line-height: 30px;
        background: #169bdf;
        color: #fff;
        font-size: 14px;
        border: 0;
        border-radius: 3px;
        outline: none;
        // position: absolute;
        // top: 50%;
        // transform: translateY(-50%);
        // right: 120px;
        cursor: pointer;
        margin-left:30px;
      }

      .addbtn {
        width: 75px;
        height: 35px;
        line-height: 30px;
        background-color: #ff904f;
        color: #fff;
        font-size: 14px;
        border: 0;
        border-radius: 3px;
        outline: none;
        // position: absolute;
        // top: 50%;
        // transform: translateY(-50%);
        // right: 20px;
        cursor: pointer;
        margin-left:30px;
      }
    }
  }

  .box {
    margin-top: 30px;
    margin-left: 30px;
    margin-right: 30px;
  }

  .pagemodel {
    margin-top: 30px;
    padding-top: 30px;
  }
}
</style>
